export default __webpack_public_path__ + "02f6e072326e79a81b14d205f88941f6.png";